import { combineReducers } from "redux";
import BedCustomizationsReducer from "./BedCustomizations/BedCustomizations.reducer";
import cartReducer from "./Cart/Cart.reducers";
import FReducer from "./FCustomizations/FCustomizations.reducer";
import MettressCustomizations from "./MettressCustomizations/MettressCustomizations.reducer";
import productsReducer from "./Products/Products.reducer";
import togglesReducer from "./Toggles/Toggles.reducer";

const rootReducer = combineReducers({
  toggles: togglesReducer,
  bedCustomizations: BedCustomizationsReducer,
  mettressCustomizations: MettressCustomizations,
  products: productsReducer,
  FCustoms: FReducer,
  cart: cartReducer,
});

export default rootReducer;
